import { useEffect, useState } from 'react';
import { breakpoints } from './../constants';

const matchMedia = () => {
  return {
    isPhone: window.matchMedia(`(max-width: ${breakpoints.phone}px)`).matches,
    isTablet: window.matchMedia(`(max-width: ${breakpoints.tablet}px)`).matches,
  };
};

export const useDevice = () => {
  const [devices, setDevices] = useState(matchMedia());

  useEffect(() => {
    function handleResize() {
      setDevices(matchMedia());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return devices;
};
